import { Component } from 'react';
import { Link } from 'react-router-dom';
import '../AllCss/ErrorBoundary.css';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('ErrorBoundary caught:', error, info);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h1>Something went wrong</h1>
          <p>We hit an unexpected error. You can try again or return home.</p>
          <div className="error-boundary-actions">
            <button type="button" className="error-boundary-btn" onClick={this.handleRetry}>
              Try again
            </button>
            <Link to="/" className="error-boundary-link">
              Go home
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
